import styled, { createGlobalStyle } from 'styled-components'
import { colors } from '@stokr/components-library'
import type { ChartTone } from 'models/chart'
import { stoColor } from 'constants/stoTheme'

/** Chart palette, from the platform colours. The only place chart colours are defined. */
export const chartColor = {
  positive: colors.freshGreen, // #69c858
  negative: colors.orangishRed, // #ee220d
  /** Funds and mining notes plot in brand blue (Figma 3990:77006); market prices stay green/red. */
  fund: stoColor.primary, // #0050ca
  /** Figma ramp/neutral/200, dashed. */
  grid: stoColor.borderSubtle,
  axisLabel: stoColor.textSecondary,
  crosshair: stoColor.textSecondary,
  tooltipBackground: stoColor.surface,
  tooltipBorder: stoColor.borderSubtle,
  tooltipText: stoColor.textSecondary,
} as const

/** Line colour for a range: red when it ends down, green otherwise. */
export const toneColor = (tone: ChartTone): string => (tone === 'down' ? chartColor.negative : chartColor.positive)

/**
 * Highcharts sizes an outside tooltip's SVG to the HTML label's box, without the callout's arrow:
 * clipped, it showed broken. The tooltip container is a child of the body, so this is global.
 */
export const ChartTooltipStyles = createGlobalStyle`
  .highcharts-tooltip-container svg {
    overflow: visible;
  }
`

export const ChartPlaceholder = styled.div`
  width: 100%;
`

export const CanvasRoot = styled.div<{ $interactive: boolean }>`
  position: relative;
  width: 100%;
  overflow: hidden;
  /* Interactive: sideways drags are the chart's (scrubbing), up and down still scroll the page. */
  touch-action: ${({ $interactive }) => ($interactive ? 'pan-y' : 'auto')};
`

/** Washes out everything right of the hovered point, like the reference design. */
export const FadeOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 100%;
  background: rgba(255, 255, 255, 0.65);
  opacity: 0;
  pointer-events: none;
`
